/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import type { TFunction } from 'i18next';

export const ROLE_ORDER = ['admin', 'operational', 'broker'] as const;

/**
 * Builds a map of role identifiers to their localized labels.
 *
 * @param t - Translation function.
 * @returns A record mapping each role id to its localized label.
 */
export function getRoleLabels(t: TFunction): Record<string, string> {
  return {
    admin: t('v2.roles.admin'),
    operational: t('v2.roles.operational'),
    broker: t('v2.roles.broker'),
  };
}

export const ROLE_COLORS: Record<string, { dot: string; text: string }> = {
  admin: { dot: 'var(--status-success-text)', text: 'var(--status-success-text)' },
  operational: { dot: 'var(--status-warning-text)', text: 'var(--status-warning-text)' },
  broker: { dot: 'var(--status-info)', text: 'var(--status-info)' },
};
